import useApi from "../../api/useApi";

const useSpotService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, spotId) => {
    return api(
      'get',
      'user/spot/' + spotId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, spotId, data) => {
    return api(
      'post',
      'user/spot/' + spotId + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotService::userUpdate: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, spotId, data) => {
    return api(
      'post',
      'user/spot/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotService::userStore: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'post',
      'user/spot/' + id + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotService::userDelete: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    objectType:'spot',
    userShow,
    userUpdate,
    userStore,
    userDelete,
  }
}
export default useSpotService
